import { ActionIcon, Burger, Group, TextInput } from '@mantine/core';
import { useState } from 'react';
import {
  IconFilterOff,
  IconPlus,
  IconSearch,
  IconX,
} from '@tabler/icons-react';
import labitatLogo from '../assets/labitat_logo_m.png';

interface HeaderBarProps {
  mobileOpened: boolean;
  toggleMobile: () => void;
  desktopOpened: boolean;
  toggleDesktop: () => void;
  query: string;
  setQuery: (value: string) => void;
  setPage: (page: number) => void;
  onClearFilters: () => void;
  clearFiltersDisabled: boolean;
  onCreateNew: () => void;
}

export default function HeaderBar({
  mobileOpened,
  desktopOpened,
  toggleMobile,
  toggleDesktop,
  query,
  setQuery,
  setPage,
  onClearFilters,
  clearFiltersDisabled,
  onCreateNew,
}: HeaderBarProps) {
  const [searchInput, setSearchInput] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    setSearchInput(value);
    setQuery(value);
  };

  const handleClear = () => {
    setSearchInput('');
    setQuery('');
  };

  const handleClearFilters = () => {
    setSearchInput(''); // Clear search input
    onClearFilters(); // Clear all other filters via parent
  };

  return (
    <Group p="md" justify="center" align="center" w="100%" wrap="nowrap">
      <Burger
        opened={mobileOpened}
        onClick={toggleMobile}
        hiddenFrom="sm"
        size="sm"
      />
      <Burger
        opened={desktopOpened}
        onClick={toggleDesktop}
        visibleFrom="sm"
        size="sm"
      />
      <TextInput
        mx="auto"
        placeholder="חיפוש בכל הקטגוריות"
        value={searchInput}
        onChange={handleChange}
        leftSection={<IconSearch size={14} />}
        rightSection={
          query ? (
            <ActionIcon
              size="sm"
              variant="transparent"
              c="dimmed"
              onClick={handleClear}
            >
              <IconX style={{ width: 14, height: 14 }} stroke={1.5} />
            </ActionIcon>
          ) : null
        }
      />
      <Group wrap="nowrap" gap="sm">
        <ActionIcon
          variant="light"
          onClick={handleClearFilters}
          disabled={clearFiltersDisabled}
        >
          <IconFilterOff size={14} />
        </ActionIcon>
        <ActionIcon variant="filled" onClick={onCreateNew}>
          <IconPlus size={16} />
        </ActionIcon>
      </Group>
      <img src={labitatLogo} alt="Labitat Logo" width="100px" />
    </Group>
  );
}
